import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { Grid, IconButton, Menu, MenuItem } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Exception } from '../../../types/exceptions'
import { useNavigate } from 'react-router'

type Props = {
  exception: Exception
  onRemoveClick: () => void
}

export default function TileMenuSection(props: Props) {
  const texts = useTranslation('exceptionList').t
  const navigate = useNavigate()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Grid>
      <IconButton
        onClick={(event: React.MouseEvent<HTMLElement>) => {
          setAnchorEl(event.currentTarget)
        }}
        sx={{ color: '#000' }}
      >
        <MoreHorizIcon/>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: '12rem',
          },
        }}
      >
        <MenuItem onClick={() => {
          handleClose()
          props.onRemoveClick()
        }}>
          {texts('tile_menu_remove')}
        </MenuItem>
        <MenuItem onClick={() => {
          navigate(`/schedule/exceptions/${props.exception.uuid}/edit`)
        }}>
          {texts('tile_menu_edit')}
        </MenuItem>
      </Menu>
    </Grid>
  )
}